module.exports = __webpack_public_path__ + "img/radiocard.13ef5986.svg";